import { QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import {
  howManyDevices,
  onlineGaming,
  peopleSimultaneously,
  peopleWorkingFromHome,
  streamingVideoQuality,
} from './internet-steps'

export const peopleSimultaneouslyAdviseInternet: ScenarioStep = {
  ...peopleSimultaneously,
}

export const howManyDevicesAdviseInternet: ScenarioStep = {
  ...howManyDevices,
}

export const peopleWorkingFromHomeAdviseInternet: ScenarioStep = {
  ...peopleWorkingFromHome,
}

export const streamingVideoQualityAdviseInternet: ScenarioStep = {
  ...streamingVideoQuality,
}

export const onlineGamingAdviseInternet: ScenarioStep = {
  ...onlineGaming,
  next: Steps.INTERNET_USAGE_INFO_ONLY,
}

export const internetUsageInfoOnly: ScenarioStep = {
  id: Steps.INTERNET_USAGE_INFO_ONLY,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.INTERNET_USAGE_INFO_ONLY,
  answerPlaceholder: 'postal-code_answerPlaceholder',
  answers: [],
  next: Steps.DONE,
}
